module.exports = __webpack_public_path__ + "img/edc_system.b3c87c3d.png";